import {
    FlyoutCategory,
    TFlyoutCategoriesState
} from "../flyoutCategories.types";

export const rebuildUrls = (
    flyoutCategory: TFlyoutCategoriesState,
    baseUrl = "/"
) => {
    const newUrl = `${baseUrl}${flyoutCategory?.url}/`;
    const newCategory: FlyoutCategory = {
        title: flyoutCategory.title,
        url: newUrl,
        subCategories:
            flyoutCategory.subCategories?.map((subCategory) =>
                rebuildUrls(subCategory, newUrl)
            ) || []
    };

    return newCategory;
};
